const business_entities = {
  permissionSource: 'api::business-entity.business-entity',
  creationTitle: 'Create Business Entity',
  creationEndPoint: '/business-entities',
  detailTitle: 'Business Entity: :title',
  detailEndPoint:
    '/business-entities/:id?populate[0]=logo&populate[1]=tel&populate[2]=fax&populate[3]=whatsapp&populate[4]=address&populate[5]=address.region&populate[6]=departments',
  detail: [
    {
      isLayout: true,
      layoutPattern: '1-1',
      children: [
        {
          isLayout: true,
          layoutPattern: '1',
          children: [
            {
              label: 'Code',
              value: 'code',
              tag: 'input',
              type: 'text',
              placeholder: 'Business Entity Code',
              required: true,
            },
            {
              label: 'Title',
              value: 'title',
              tag: 'input',
              type: 'text',
              placeholder: 'Business Entity Title',
              required: true,
            },
            {
              label: 'Website',
              value: 'website',
              tag: 'input',
              type: 'text',
              placeholder: 'Business Entity Website URL',
            },
            {
              label: 'Email',
              value: 'email',
              tag: 'input',
              type: 'email',
              placeholder: 'Business Entity Email',
            },
            {
              isLayout: true,
              layoutPattern: '1-1-2',
              children: [
                {
                  label: 'Telephone',
                  value: 'tel.country_code',
                  placeholder: '+852',
                  tag: 'input',
                  type: 'number',
                },
                {
                  label: '',
                  value: 'tel.area_code',
                  placeholder: '123',
                  tag: 'input',
                  type: 'number',
                },
                {
                  label: '',
                  value: 'tel.contact_number',
                  placeholder: '2121 1323',
                  tag: 'input',
                  type: 'number',
                },
              ],
            },
          ],
        },
        {
          label: 'Logo',
          value: 'logo',
          tag: 'media',
          acceptFile: 'image/*',
        },
      ],
    },
    {
      isLayout: true,
      layoutPattern: '1-1',
      children: [
        {
          isLayout: true,
          layoutPattern: '1-1-2',
          children: [
            {
              label: 'Fax',
              value: 'fax.country_code',
              placeholder: '+852',
              tag: 'input',
              type: 'number',
            },
            {
              label: '',
              value: 'fax.area_code',
              placeholder: '123',
              tag: 'input',
              type: 'number',
            },
            {
              label: '',
              value: 'fax.contact_number',
              placeholder: '2121 1323',
              tag: 'input',
              type: 'number',
            },
          ],
        },
        {
          isLayout: true,
          layoutPattern: '1-1-2',
          children: [
            {
              label: 'WhatsApp',
              value: 'whatsapp.country_code',
              placeholder: '+852',
              tag: 'input',
              type: 'number',
            },
            {
              label: '',
              value: 'whatsapp.area_code',
              placeholder: '123',
              tag: 'input',
              type: 'number',
            },
            {
              label: '',
              value: 'whatsapp.contact_number',
              placeholder: '2121 1323',
              tag: 'input',
              type: 'number',
            },
          ],
        },
        {
          label: 'Departments',
          value: 'departments',
          tag: 'multi-select',
          dataSourceUrl: '/departments',
          dataLabel: 'title',
        },
      ],
    },
    {
      label: 'Address',
      value: 'address.address_line_1',
      placeholder: 'Address Line 1',
      tag: 'input',
      type: 'text',
    },
    {
      value: 'address.address_line_2',
      placeholder: 'Address Line 2',
      tag: 'input',
      type: 'text',
    },
    {
      value: 'address.address_line_3',
      placeholder: 'Address Line 3',
      tag: 'input',
      type: 'text',
    },
    {
      isLayout: true,
      layoutPattern: '1-1-1',
      children: [
        {
          label: 'Country',
          value: 'address.country',
          tag: 'input',
          type: 'text',
        },
        {
          label: 'Region',
          value: 'address.region',
          tag: 'single-select',
          dataSourceUrl: '/regions',
          dataLabel: 'name',
        },
        {
          label: 'Zip',
          value: 'address.zip',
          tag: 'input',
          type: 'text',
        },
      ],
    },
    {
      isLayout: true,
      layoutPattern: '1-1-1',
      children: [
        {
          label: 'Create Date / Time',
          value: 'custom_created_at',
          tag: 'static-text',
        },
        {
          label: 'Publish Date / Time',
          value: 'publishedAt',
          tag: 'static-text',
        },
        {
          label: 'Update Date / Time',
          value: 'custom_updated_at',
          tag: 'static-text',
        },
      ],
    },
  ],
}

export default business_entities
